import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { buildHighlightedHtml } from './universal-search.utils';

@Pipe({
    standalone: false,
    name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, query: string): SafeHtml {
        const html = buildHighlightedHtml(text ?? '', query ?? '');
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
